module.exports = __webpack_public_path__ + "img/dagou.ce505092.png";